import "../App.css";
import Select, { createFilter } from "react-select";
import React, { useEffect, useState, useRef } from "react";
import { useHistory, Redirect } from "react-router-dom";
import { getToken, isAuth } from "../user/User";
import createTask2 from "../api/CreateTask";
import ClipLoader from "react-spinners/ClipLoader";
import toast, { Toaster } from 'react-hot-toast';
import LogoutButton from "../components/LogoutButton";
import getUserInfo from "../api/GetUserInfo";
import crypto from "crypto-js";
import CheckHashState from "../api/CheckHashState";
import getVttViaHash from "../api/GetVttViaHash";
import ProgressBar from "@ramonak/react-progress-bar";
import { LanguagesList } from "../files/LanguagesList_iso1";
import Autocomplete from '@mui/material/Autocomplete';
import { DialectLanguagesList } from "../files/LanguagesList_iso3";
import { Button } from "@mui/material";
import TextField from '@mui/material/TextField';
const options = [
  { value: "de", label: "German" },
  { value: "en", label: "English" },
  { value: "ar", label: "Arabic" },
  { value: "ua", label: "Ukrainian" },
  { value: "other", label: "Other" },
];

//const otherLanguages = LanguagesList
const otherLanguages = DialectLanguagesList
const DialectLanguages = DialectLanguagesList
const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "white" : "#093545",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition };
  },
};

function CreateTask() {
  var intervalId;
  const history = useHistory();
  const [selectedOption, setSelectedOption] = useState("other");
  const [languageSelected, setLanguageSelected] = useState(false);
  const [languageSelected2, setLanguageSelected2] = useState(false);
  const [currentUserInfo, setCurrentUserInfo] = useState(false);
  const [selectedOption2, setSelectedOption2] = useState(false);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [createTask, setCreateTask] = useState(false);
  const [vttText, setVttText] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [taskId, setTaskId] = useState(false);
  const [transDuration, setTransDuration] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [dialectList, setDialectList] = useState([]);

  const onBrowseClick = () => {
    // `current` points to the mounted file input element
    inputFile.current.click();
  };

  useEffect(() => {
    if (!currentUserInfo) {
      loadUserInfo()
    }

  });


  const loadUserInfo = async () => {
    let token = getToken();
    let userInfo = await getUserInfo(token);

    setCurrentUserInfo(userInfo)

    console.log("........................")
    console.log(userInfo)
  }

  const hashFile = (inputFile) => {

    try {
      return crypto.SHA256(inputFile.current.files[0].name + inputFile.current.files[0].size).toString()
    }
    catch (error) {

    }
  }

  const onSelectFile = async () => {
    if (inputFile.current.files.length > 0) {
      console.log(inputFile)
      let hash = hashFile(inputFile);
      console.log(hash)
      console.log(inputFile)
      let response = await CheckHashState(hash, getToken())
      console.log("response")
      console.log(response)
      if (!response.exists) {
        setCreateTask(true)
        setTitle(inputFile.current.files[0].name)
      }
      else {
        if (response.status == "done") {
          let vtt = await getVttViaHash(hash, getToken());
          console.log(vtt)
          setTaskId(response.task_id)
          setVttText(vtt)
        }
        else {
          setUploaded(true)
          onTranscribing()
        }
      }


    }
  };

  const inputFile = useRef(null);


  const onTranscribing = async () => {
    intervalId = setInterval(function () {
      if (inputFile) {
        let response = CheckHashState(hashFile(inputFile), getToken()).then(
          (r) => {

            if (r.exists && r.status == "done") {
              onSelectFile()
            }
            else {

              setTransDuration(r.duration)
              if (r.status == "failed") {
                toast.error("A problem occurred while transcribing, please try again.", { position: "bottom-center" });
                clearInterval(intervalId)
              }
            }
          }
        )
      }
    }, 5000);
  }

  const createIso3List = async (lang) => {
    var dList = DialectLanguages.filter((e) => {

      if (e.label.includes(lang)) {
        //console.log(e)
        return e;
      }
    })

    setDialectList(dList)

  }

  const onCreateTheTaskClick = async () => {

    if (selectedOption == "") {
      toast.error("please select the language of the audio file", { position: "bottom-center" });
      return;
    }
    if (inputFile.current.files.length < 1) {
      toast.error("please select an audio file ", { position: "bottom-center" });
      return;
    }



    let token = getToken();

    if (currentUserInfo.restricted && inputFile.current.files[0].size > 838860800) {
      toast.error("You have a restricted account, contact the adminstrator for more Info", { position: "bottom-center" });
      setLoading(false);
      return;
    }
    setLoading(true);
    let response
    if (selectedOption != "other")
      response = await createTask2(token, inputFile, title, selectedOption, hashFile(inputFile), setUploadProgress,"");
    else {
      if (selectedOption2) {
        response = await createTask2(token, inputFile, title, selectedOption2.label, hashFile(inputFile), setUploadProgress,selectedOption2.value);
      }
      else {
        toast.error("Please select the exact language to proceed.", { position: "bottom-center" });
        setLoading(false);
        return;
      }
    }

    console.log("----------------------------------------------")
    setLoading(false);

    if (response) {
      toast.success("Task uploaded successfully", { position: "bottom-center" });
      setUploaded(true)
      onTranscribing()




    }
    else
      toast.error("A problem occurred while uploading the task", { position: "bottom-center" });
  };

  if (isAuth()) {
    return (
      <div className="App">
        <header className="App-header">
          <LogoutButton></LogoutButton>
          <h1 style={{ color: "#ffffff", fontSize: 75, marginBottom: 10 }}>
            Transcript Correction Tool
          </h1>
          <input
            type="file"
            id="file"
            ref={inputFile}
            style={{ display: "none" }}
            onChange={onSelectFile}
          />
          {!loading && !uploaded && <div
            style={{
              backgroundColor: "rgba(255,255,255,0.05)",
              padding: 20,
              borderRadius: 10,
              width: "30%",
            }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
              }}
            >

              <button
                onClick={onBrowseClick}
                style={{ alignSelf: "flex-start", width: '100%', height: 35 }}
              >
                {'Select a File'}
              </button>
            </div>
            <div style={{ height: 10 }}></div>
            {title == "" ? null : <input
              onChange={(e) => {
                //setTitle(e.target.value);
              }}
              style={{
                backgroundColor: "#224957",
                width: "100%",
                height: 30,
                marginTop: 10,
                borderRadius: 7,
                color: "#ffffff",
                borderWidth: 0,
              }}
              value={title}
              placeholder={'File Name'}
              readOnly={true}
            ></input>}

            <div style={{ height: 10 }}></div>
            {createTask && <>
              <h1 style={{ color: "#ffffff", fontSize: 20, marginBottom: 0, marginTop: 0 }}>
                Information
              </h1>
              <h1 style={{ color: "#ffffff", fontSize: 15, marginBottom: 0, marginTop: 0 }}>
                We do not have a Transcription for this media file, if you want to create a transcription, please select a language then submit.
              </h1>
              <h1 style={{ color: "#ffffff", fontSize: 15, marginBottom: 0, marginTop: 0 }}>
                If your language is not listed please select „Other“ (This will create a blank transcript).
              </h1>
              <div>
              </div>
              <h1 style={{ color: "#ffffff", fontSize: 20 }}>
                Select Language
              </h1>
              <Select

                styles={customStyles}
                defaultValue={{ value: "other", label: "Language" }}
                onChange={(e) => {
                  setLanguageSelected(true)
                  setSelectedOption(e.value)
                }}
                options={options}
              />


              {languageSelected && selectedOption == 'other' && <>
                <h1 style={{ color: "#ffffff", fontSize: 20 }}>
                  Please type/select the language for which a blank transcript will be generated
                </h1>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={otherLanguages}
                  sx={{backgroundColor:'#ffffff'}}
                  styles={customStyles}
                  renderInput={(params) => <TextField {...params} label="Search" sx={{alignSelf:'center',textAlign:'center'}} />}
                  onChange={(e,v) => {
                    setSelectedOption2(v)
                    setLanguageSelected2(true)
                    createIso3List(e.label)
                  }}
                />
                {/*<Select
                  styles={customStyles}
                  defaultValue={{ value: "other", label: "Language" }}
                  onChange={(e) => {
                    setSelectedOption2(e.value)
                    setLanguageSelected2(true)
                    createIso3List(e.label)
                  }}
                  options={otherLanguages}
                />*/}
                <div style={{ height: 10 }}></div>
              </>}

              {/*languageSelected&&selectedOption == 'other' &&languageSelected2&& <>
              <h1 style={{ color: "#ffffff", fontSize: 20 }}>
                Please select the dialect
              </h1>
              <Select

                styles={customStyles}
                defaultValue={{ value: "other", label: "Language" }}
                onChange={(e) => setSelectedOption2(e.value)}
                options={dialectList}
              />
                <div style={{ height: 25 }}></div>
              </>*/}
              <button
                onClick={onCreateTheTaskClick}
                style={{
                  backgroundColor: "#20DF7F",
                  width: "100%",
                  height: 35,
                  borderRadius: 7,
                  color: "white",
                }}
              >
                Submit
              </button>
              <div style={{ height: 10 }}></div>
              <ClipLoader color={"#ffffff"} loading={loading} size={40} />
            </>
            }
          </div>}





          <div style={{ height: 20 }}></div>
          {!loading && !uploaded && currentUserInfo && currentUserInfo.canMakeAssignments && <div

          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >

              <Button style={{ backgroundColor: 'rgba(255,255,255,0.05)', width: 200 }} onClick={() => { history.push("/adminpage"); }}>
                listener mode
              </Button>
            </div>
            <div style={{ height: 10 }}></div>
            {title == "" ? null : <input
              onChange={(e) => {
                //setTitle(e.target.value);
              }}
              style={{
                backgroundColor: "#224957",
                width: "100%",
                height: 30,
                marginTop: 10,
                borderRadius: 7,
                color: "#ffffff",
                borderWidth: 0,
              }}
              value={title}
              placeholder={'File Name'}
              readOnly={true}
            ></input>}

            <div style={{ height: 10 }}></div>

          </div>}

          {loading && <div
            style={{
              backgroundColor: "rgba(255,255,255,0.05)",
              padding: 20,
              borderRadius: 10,
              width: "30%",
            }}
          >
            <h1 style={{ color: "#ffffff", fontSize: 30 }}>
              Information
            </h1>
            <h1 style={{ color: "#ffffff", fontSize: 20 }}>
              Please wait, your file is being uploaded, this may take a while.
              Please do not close this window
            </h1>
            <ProgressBar bgColor="#20DF7F" completed={uploadProgress}></ProgressBar>
            <div style={{ height: 25 }}></div>
            <ClipLoader color={"#ffffff"} loading={true} size={40} />

            <div
              style={{
                flexDirection: "row",
                display: "flex",
              }}
            >


              <div style={{ height: 25 }}></div>

            </div>
          </div>}

          {uploaded && (<div
            style={{
              backgroundColor: "rgba(255,255,255,0.05)",
              padding: 20,
              borderRadius: 10,
              width: "30%",
            }}
          >
            <h1 style={{ color: "#ffffff", marginBottom: 0, fontSize: 30 }}>
              Information
            </h1>
            <h1 style={{ color: "#ffffff", fontSize: 20, marginBottom: 0, marginTop: 0 }}>
              The File has been uploaded successfully.

            </h1>
            <h1 style={{ color: "#ffffff", fontSize: 20, marginBottom: 0, marginTop: 0 }}>

              Currently your file is being transcribed, one hour of audio, may take up to 30 minutes.

            </h1>
            <h1 style={{ color: "#ffffff", fontSize: 20, marginBottom: 0, marginTop: 0 }}>

              You can close the window and comeback later or you can wait.

            </h1>
            {transDuration && (<h1 style={{ color: "#ffffff", fontSize: 20, marginBottom: 0, marginTop: 0 }}>

              Estimated duration: {transDuration}

            </h1>)}
            <div
              style={{
                flexDirection: "row",
                display: "flex",
              }}
            >


              <div style={{ height: 25 }}></div>

            </div>
          </div>)}


          {vttText && (
            <Redirect
              to={{
                pathname: "tool",
                state: {
                  text: vttText,
                  files: inputFile.current.files,
                  taskId: taskId
                },
              }}
            ></Redirect>
          )}
        </header>
        <Toaster></Toaster>
      </div>
    );
  } else {
    return <Redirect to="login"></Redirect>;
  }
}

export default CreateTask;